import { useMemo, useState } from 'react'
import { styled, useTheme, Link } from '@mui/material'
import { useLocation } from 'react-router-dom'
import Logo from 'assets/images/svg/common/logo.svg'
import Games from './Games'
import { Box, Button, Typography } from '@mui/material'
import { useUser } from 'state/user/hooks'
import Avatar from './Avatar'
import { setAccountModal } from 'state/application/reducer'
import { useAppDispatch } from 'state'
import { useAccountModal } from 'state/application/hooks'
import AccountCenter from 'pages/AccountCenter'
import NotificationModel from './NotificationModel'
import { HOST } from 'config'

const HeaderBox = styled('header')`
  height: 56px;
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 12;
  position: fixed;
  .logo {
    position: absolute;
    padding: 0 !important;
    z-index: 13;
    width: 88px;
    height: 24px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url(${Logo});
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all 200ms;
  }
  > div {
    width: 100%;
    padding: 0 40px 0 75px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    background-color: ${props => props.theme.colors.black};
    z-index: 12;
    > nav {
      flex: 1;
      display: flex;
      > a {
        margin-right: 64px;
        text-decoration: none;
      }
    }
  }
`
const Right = styled('div')`
  display: flex;
  button:last-of-type {
    margin-left: 24px;
  }
`

const NavItem = styled(Link)`
  height: 56px;
  color: ${props => props.theme.colors.white};
  line-height: 30px !important;
  text-decoration: none;
  overflow: hidden;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  .first-name {
    transition: all 200ms;
    margin-top: 13px;
    text-decoration: none;
  }
  .second-name {
    transition: all 200ms;
    opacity: 0;
  }
  :hover {
    .first-name {
      opacity: 0;
      margin-top: -25px;
    }
    .second-name {
      opacity: 1;
      margin-top: 7px;
    }
  }
`

// const NavSelectItem = styled(NavLink)`
//   color: ${props => props.theme.colors.white};
//   height: 56px;
//   line-height: 30px !important;
//   .first-name {
//     transition: all 200ms;
//     margin-top: 13px;
//   }
//   .second-name {
//     transition: all 200ms;
//     opacity: 0;
//   }
//   :hover {
//     .first-name {
//       opacity: 0;
//       margin-top: -25px;
//     }
//     .second-name {
//       opacity: 1;
//       margin-top: 7px;
//     }
//   }
// `
const LogInBox = styled(Box)`
  height: 56px;
  overflow: hidden;
  .MuiTypography-root {
    height: 56px;
  }
  .first-name {
    transition: all 200ms;
    margin-top: 15px;
  }
  .second-name {
    transition: all 200ms;
    opacity: 0;
  }
  :hover {
    .first-name {
      opacity: 0;
      margin-top: -25px;
    }
    .second-name {
      opacity: 1;
      margin-top: 12px;
    }
  }
`
export default function Header({ classNameString, sx = {} }: { classNameString?: string; sx?: object }) {
  const location = useLocation()
  // const [accountModal, setAccountModal] = useState('close')
  const user = useUser()
  // console.log(user)
  const theme = useTheme()
  // const navigate = useNavigate()
  const accountModal = useAccountModal()
  const dispatch = useAppDispatch()
  const [openGames, setOpenGames] = useState<boolean>(false)

  const checkHidden = useMemo(() => {
    const hiddenPagePathList = ['game/midgardsaga/event', '/login', 'game/OathofPeak/earlyaccess']
    const mapHiddenList = hiddenPagePathList.some(path => location.pathname.indexOf(path) > -1)
    return !mapHiddenList
  }, [location.pathname])

  return (
    <>
      {checkHidden && (
        <HeaderBox className={classNameString} sx={{ ...sx }}>
          {location.pathname.indexOf('/game/') === -1 && (
            <Box
              onClick={() => {
                window.location.href = HOST
                // navigate('/')
              }}
              className="logo"
            ></Box>
          )}
          <div>
            <nav>
              <NavItem href={HOST}>
                <Box className="first-name">Home</Box>
                <Box className="second-name">Home</Box>
              </NavItem>
              <NavItem
                href="/game"
                onClick={e => {
                  e.preventDefault()
                }}
                onMouseEnter={() => setOpenGames(true)}
                onMouseLeave={() => setOpenGames(false)}
              >
                <Box className="first-name">Games</Box>
                <Box className="second-name">Games</Box>
                {openGames && <Games clickItem={() => setOpenGames(false)} open={openGames} />}
              </NavItem>
              <NavItem href="/nft">
                <Box className="first-name">Market</Box>
                <Box className="second-name">Market</Box>
              </NavItem>
              <NavItem href="/mint">
                <Box className="first-name">Mint</Box>
                <Box className="second-name">Mint</Box>
              </NavItem>
              <NavItem href="/community">
                <Box className="first-name">Community</Box>
                <Box className="second-name">Community</Box>
              </NavItem>
            </nav>
            <Right>
              {user ? (
                <>
                  <NotificationModel></NotificationModel>
                  <Box display={'flex'} alignItems={'center'}>
                    {/* <NavItem href="/mynft">
                      <Box className="first-name">My NFT</Box>
                      <Box className="second-name">My NFT</Box>
                    </NavItem> */}
                    <Avatar user={user}></Avatar>
                  </Box>
                </>
              ) : (
                <Box display="flex" height="56px">
                  <Typography
                    variant="button"
                    onClick={() => {
                      window.location.href = `/login?redirectUrl=${encodeURIComponent(window.location.href)}`
                    }}
                    color={theme.colors.white}
                    component="div"
                    textTransform={'none'}
                    fontWeight={700}
                  >
                    <LogInBox>
                      <Box className="first-name">Log In</Box>
                      <Box className="second-name">Log In</Box>
                    </LogInBox>
                  </Typography>
                  <Button
                    color="primary"
                    onClick={() => {
                      window.location.href = `/login?redirectUrl=${encodeURIComponent(
                        window.location.href
                      )}&type=Register`
                    }}
                    sx={{
                      height: '56px',
                      marginRight: 0,
                      padding: '0 30px',
                      marginLeft: '36px',
                    }}
                    variant="contained"
                  >
                    <LogInBox>
                      <Box className="first-name"> Sign Up</Box>
                      <Box className="second-name"> Sign Up</Box>
                    </LogInBox>
                  </Button>
                </Box>
              )}
            </Right>
          </div>
          <AccountCenter active={accountModal} handleClose={() => dispatch(setAccountModal('close'))}></AccountCenter>
        </HeaderBox>
      )}
    </>
  )
}
